import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Card, Button } from '@mui/material';
import { useMediaQueries } from '../usecontext/UseProvider';
import { FaPlay } from 'react-icons/fa';
import { getCustomerReviewVideo } from '../services/CustomerReviewVideo';
import Header from '../adminComponents/header/Header'
import HappyCustomerModal from '../adminComponents/happycustomermodal/HappyCustomerModal';

const HappyCustomerPage = () => {
    const { isSmallScreen, setLoading } = useMediaQueries();
    const [customerReviewData, setCustomerReviewData] = useState([])
    const [openModal, setOpenModal] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const getCustomerReviewVideoData = async () => {
        try {
            setLoading(true);
            const response = await getCustomerReviewVideo();
            setCustomerReviewData(response?.customerReviewVideo);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        getCustomerReviewVideoData();
    }, []);

    const videoRefs = useRef([]);
    const [isPlaying, setIsPlaying] = useState(
        Array(customerReviewData?.length).fill(false)
    );

    const handlePlayPause = (index) => {
        const video = videoRefs.current[index];
        const updatedPlayingState = [...isPlaying];

        if (video.paused) {
            video.play();
            updatedPlayingState[index] = true;
        } else {
            video.pause();
            updatedPlayingState[index] = false;
        }

        setIsPlaying(updatedPlayingState);
    };

    const handleVideoEnd = (index) => {
        const updatedPlayingState = [...isPlaying];
        updatedPlayingState[index] = false;
        setIsPlaying(updatedPlayingState);
    };

    const handleOnEdit = (video) => {
        setSelectedVideo(video);
        setOpenModal(true);
    };

    const handleUpdateSuccess = () => {
        getCustomerReviewVideoData(); // Refresh the data
    };

    return (
        <>
            <Header title="Happy Customer" />
            <Box sx={{ pt: 3 }}>
                <Grid container spacing={3}>
                    {customerReviewData.map((video, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            lg={3}
                            key={index}
                            data-aos="zoom-in"
                            data-aos-delay={index * 200}
                        >
                            <Card
                                sx={{
                                    backgroundColor: 'transparent',
                                    position: 'relative',
                                    boxShadow: 'none', textAlign: 'center'
                                }}
                            >
                                <Box
                                    component="video"
                                    ref={(el) => (videoRefs.current[index] = el)}
                                    src={video?.video?.url}
                                    loop={false}
                                    muted
                                    onEnded={() => handleVideoEnd(index)}
                                    sx={{
                                        borderRadius: '20px',
                                        height: '330px',
                                        maxWidth: { lg: '300px', xs: '100%' },
                                        objectFit: 'cover',
                                    }}
                                    onClick={() => handlePlayPause(index)}
                                />
                                {!isPlaying[index] && (
                                    <Box
                                        onClick={() => handlePlayPause(index)}
                                        sx={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            textAlign: 'center',
                                            color: '#fff',
                                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                            borderRadius: '50%',
                                            width: '60px',
                                            height: '60px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <FaPlay style={{ height: '20px', width: '20px' }} />
                                    </Box>
                                )}
                                <Button
                                    variant="varient"
                                    size={isSmallScreen ? 'small' : 'medium'}
                                    sx={{
                                        fontWeight: 400,
                                        backgroundColor: '#01A0E2',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        mt: 3,
                                        px: 3,
                                    }}
                                    onClick={() => handleOnEdit(video)}>
                                    Change Video
                                </Button>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <HappyCustomerModal 
                open={openModal} 
                setOpen={setOpenModal} 
                videoData={selectedVideo}
                onUpdateSuccess={handleUpdateSuccess}
            />
        </>
    )
}

export default HappyCustomerPage